import * as React from 'react';
// mui
import {
  Container,
  Grid,
  Paper,
  List,
  useTheme,
  useMediaQuery,
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
} from '@mui/material';
// icons
import ChecklistIcon from '@mui/icons-material/Checklist';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BoltIcon from '@mui/icons-material/Bolt';
import EmailIcon from '@mui/icons-material/Email';
// router
import { useNavigate } from 'react-router';
// components
import ReadOnlyTaskItem from '../components/LandingPage/ReadOnlyTaskItem';
import RoadmapTimeline from '../components/LandingPage/RoadmapTimeline';

const ButtonAppBar = () => {
  const navigate = useNavigate();

  const navigateToAuth = () => {
    navigate('/auth');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar sx={{background: '#121212'}} position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Task Manager
          </Typography>
          <Button variant='contained' onClick={navigateToAuth} color="primary">
            Login / Signup
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default function LandingPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        background: (theme) =>
          `linear-gradient(to bottom right, 
        ${theme.palette.primary.main}44 0%, 
        ${theme.palette.background.default}FF 100%)`
      }}
    >
      <ButtonAppBar />
      <Container sx={{ mt: 4 }}>
        <Container sx={{ my: 8 }}>
          <Typography textAlign="center" variant="h4">
            Task Management <span style={{ color: '#556cd6' }}>Reinvented</span>
          </Typography>
          <Typography textAlign="center" variant="subtitle1" sx={{ mt: 1, mb: 4 }}>
            Discover a powerful, intelligent task manager built for the way you actually work.
          </Typography>
        </Container>

        <Box sx={{ mb: isMobile ? 4 : 6  }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderColor: 'primary.main',
              backgroundColor: 'background.default'
            }}
          >
            <List>
              <ReadOnlyTaskItem
                title="Plan Product Launch"
                completed={false}
                dueDate="Yesterday"
                priority={4}
                energy={4}
                time={5}
                project="Work"
                subtasksCompleted={1}
                totalSubtasks={3}
              />
              <Box sx={{ pl: 4 }}>
                <ReadOnlyTaskItem
                  title="Design Landing Page"
                  completed={false}
                  dueDate="Today"
                  priority={3}
                  energy={3}
                  time={3}
                  project="Design"
                  subtasksCompleted={1}
                  totalSubtasks={1}
                />
                <ReadOnlyTaskItem
                  title="Write Marketing Plan"
                  completed={false}
                  dueDate="Tomorrow"
                  priority={5}
                  energy={4}
                  time={4}
                  project="Marketing"
                  subtasksCompleted={0}
                  totalSubtasks={1}
                />
                <ReadOnlyTaskItem
                  title="Email Clients"
                  completed={true}
                  dueDate="2025-04-25"
                  priority={2}
                  energy={3}
                  time={2}
                  subtasksCompleted={3}
                  totalSubtasks={3}
                />
              </Box>
            </List>
          </Paper>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {[
            {
              title: 'Smart Dependencies',
              desc: 'Tasks can require subtasks, making project tracking accurate and hierarchical.',
              icon: <ChecklistIcon color="primary" sx={{ fontSize: 40 }} />
            },
            {
              title: 'Infinite Depth',
              desc: 'Nest tasks within tasks forever, for infinite granularity — no limits, just freedom.',
              icon: <AccountTreeIcon color="primary" sx={{ fontSize: 40 }} />
            },
            {
              title: 'Smart Scheduling',
              desc: 'Tasks with priorities, projects, time & energy estimates — ready to be auto-sorted.',
              icon: <AutoAwesomeIcon color="primary" sx={{ fontSize: 40 }} />
            },
            {
              title: 'Energy + Time-Based Suggestions',
              desc: 'Our algorithm finds the ideal task for your current energy and available time.',
              icon: <BoltIcon color="primary" sx={{ fontSize: 40 }} />
            }
          ].map((feature, index) => (
            <Grid size={isMobile ? 12 : 6} key={index}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  borderColor: 'primary.main',
                  backgroundColor: 'background.default',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Box mb={1}>{feature.icon}</Box>
                <Typography variant="h6" gutterBottom>{feature.title}</Typography>
                <Typography variant="body2">{feature.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <RoadmapTimeline />
          
        {/* Call to Action */}
        <Box textAlign="center" sx={{ mt: 6, mb: 0 }}>
          <Button
            variant="contained"
            size="large"
            sx={{ mb: 6, mr: 4 }}
            onClick={() => window.location.href = '/auth'}
          >
            Get Started
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<EmailIcon />}
            sx={{ mb: 6 }}
            href="mailto:contact@psylucidos.xyz"
          >
            Contact Us
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
